import { useQuery } from "@tanstack/react-query";
import { userService } from "@/services/userService";

export const allAdvisorsKeys = {
  all: ['allAdvisors'],
};

// This hook fetches all legal advisors by recursively loading all pages
export const useAllAdvisors = () => {
  return useQuery({
    queryKey: allAdvisorsKeys.all,
    queryFn: async () => {
      // Get the first page to determine total pages
      const firstPageResponse = await userService.getlegalAdvisors(1);
      
      // Extract pagination data
      const pagination = firstPageResponse.pagination || {};
      const totalPages = pagination.last_page || 1;
      
      // Store all advisors from first page
      let allAdvisors = [];
      
      // Extract advisors from first page
      if (Array.isArray(firstPageResponse.data)) {
        allAdvisors = [...firstPageResponse.data];
      } else if (firstPageResponse.data?.users && Array.isArray(firstPageResponse.data.users)) {
        allAdvisors = [...firstPageResponse.data.users];
      }
      
      // If there are more pages, fetch them in parallel
      if (totalPages > 1) {
        // Create an array of page numbers from 2 to totalPages
        const remainingPages = Array.from({ length: totalPages - 1 }, (_, i) => i + 2);
        
        // Fetch all remaining pages in parallel
        const remainingPagesData = await Promise.all(
          remainingPages.map(page => userService.getlegalAdvisors(page))
        );
        
        // Process and add advisors from each page
        remainingPagesData.forEach(pageResponse => {
          if (Array.isArray(pageResponse.data)) {
            allAdvisors = [...allAdvisors, ...pageResponse.data];
          } else if (pageResponse.data?.users && Array.isArray(pageResponse.data.users)) {
            allAdvisors = [...allAdvisors, ...pageResponse.data.users];
          }
        });
      }
      
      return allAdvisors;
    },
    // Keep cached for 5 minutes to avoid frequent refetching
    staleTime: 5 * 60 * 1000,
    // Retry fetching when focus returns to the page (to handle new advisor additions)
    refetchOnWindowFocus: true,
  });
}; 